import { type LiveChannel } from '@setplex/tria-api'
import { formatUrl } from '~/shared/helpers/image'

export const formatChannel = (channel: LiveChannel) => {
  return {
    ...channel,
    logo: formatUrl({
      url: channel.logo || '',
      size: '300x300',
      fmt: 'webp',
    }),
  }
}
